module.exports = __webpack_public_path__ + "static/media/team.3e4b11b7.png";